import { queryOptions } from "@tanstack/react-query";

import { apiUrl, fetchJson } from "@workspace/base-api";
import type { OperationItem } from "@workspace/operations";

import type { Profile } from "../types";

export function getProfileOptions(tenant: string, userId: string) {
	return queryOptions({
		queryKey: [tenant, userId, "profile"],
		queryFn: () => getProfile(tenant),
	});
}

export async function getProfile(tenant: string) {
	const response = await fetchJson<OperationItem<Profile>>(
		new URL("/profile", apiUrl),
		{
			method: "GET",
			headers: {
				tenant: tenant,
			},
		},
	);

	return response;
}
